import React from 'react';
import type { ChartArtifactPayload } from '@cotera/api';
import { cn } from '@cotera/client/v0/lib/utils';
import { SparkShapes } from './chart-spark-shapes';
import { SPARK_VIEW_HEIGHT, SPARK_VIEW_WIDTH } from './chart-spark-utils';

const SPARK_HEIGHT = 40;

const sparkSvgProps = (height: number) => ({
  viewBox: `0 0 ${SPARK_VIEW_WIDTH} ${SPARK_VIEW_HEIGHT}`,
  width: '100%' as const,
  height,
  preserveAspectRatio: 'none' as const,
  className: 'block',
  'aria-hidden': true as const,
});

export const ChartSparkPreview: React.FC<{
  payload: ChartArtifactPayload;
  className?: string;
  height?: number;
}> = ({ payload, className, height = SPARK_HEIGHT }) => {
  return (
    <div
      className={cn('w-full min-w-[48px] overflow-hidden rounded', className)}
      style={{ height }}
    >
      <svg {...sparkSvgProps(height)}>
        <SparkShapes payload={payload} />
      </svg>
    </div>
  );
};
